import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "container p-0 m-0",
  "data-kt-landing": "true"
}, null, -1)
const _hoisted_2 = { class: "divFormularioFam justify-content-center align-content-center text-center" }
const _hoisted_3 = { class: "landingSubtitle pb-5" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "mr-2 pt-5 textoCentrado" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "mr-2 pt-5 textoCentrado" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.i18n("formularioInscripcion")), 1),
      _createElementVNode("div", {
        class: "textoJustificado landingInfoText fs-5",
        innerHTML: _ctx.$t('descripcionFormularioFamilias')
      }, null, 8, _hoisted_4),
      (!_ctx.token)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: "/formulario-familias-paso-inicial",
                class: "btn btn-primary botonFormSecondary",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.i18n("cumplimentarCuestionarioBtn")), 1)
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.token)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_router_link, {
                to: _ctx.startStepUrl,
                class: "btn btn-primary botonFormSecondary",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.i18n("cumplimentarCuestionarioBtn")), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}